import {
  TPartSettingsTabKey,
} from '@/page/part/settings.ts';

const tabs: Record<TPartSettingsTabKey, string> = {
  attributes: 'Atribúty',
  tableView: 'Prehľadová tabuľka',
};

export default {
  tabs,
};
